var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0014 15.1673H6.00138C2.38138 15.1673 0.834717 13.6207 0.834717 10.0007V6.00065C0.834717 2.38065 2.38138 0.833984 6.00138 0.833984H9.33472C9.60805 0.833984 9.83472 1.06065 9.83472 1.33398C9.83472 1.60732 9.60805 1.83398 9.33472 1.83398H6.00138C2.92805 1.83398 1.83472 2.92732 1.83472 6.00065V10.0007C1.83472 13.074 2.92805 14.1673 6.00138 14.1673H10.0014C13.0747 14.1673 14.1681 13.074 14.1681 10.0007V6.66732C14.1681 6.39398 14.3947 6.16732 14.6681 6.16732C14.9414 6.16732 15.1681 6.39398 15.1681 6.66732V10.0007C15.1681 13.6207 13.6214 15.1673 10.0014 15.1673Z",
    fill: "#0A5EF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6681 7.16633H12.0014C9.72138 7.16633 8.83472 6.27967 8.83472 3.99967V1.333C8.83472 1.133 8.95472 0.946334 9.14138 0.873C9.32805 0.793 9.54138 0.839667 9.68805 0.979667L15.0214 6.313C15.1614 6.453 15.2081 6.673 15.1281 6.85967C15.0481 7.04633 14.8681 7.16633 14.6681 7.16633ZM9.83472 2.53967V3.99967C9.83472 5.71967 10.2814 6.16633 12.0014 6.16633H13.4614L9.83472 2.53967Z",
    fill: "#0A5EF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66797 9.16602H4.66797C4.39464 9.16602 4.16797 8.93935 4.16797 8.66602C4.16797 8.39268 4.39464 8.16602 4.66797 8.16602H8.66797C8.9413 8.16602 9.16797 8.39268 9.16797 8.66602C9.16797 8.93935 8.9413 9.16602 8.66797 9.16602Z",
    fill: "#0A5EF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33464 11.834H4.66797C4.39464 11.834 4.16797 11.6073 4.16797 11.334C4.16797 11.0607 4.39464 10.834 4.66797 10.834H7.33464C7.60797 10.834 7.83464 11.0607 7.83464 11.334C7.83464 11.6073 7.60797 11.834 7.33464 11.834Z",
    fill: "#0A5EF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveProfileIcon);
export default __webpack_public_path__ + "static/media/save-profile-icon.45cee10f9ff808ec53e7bde075d1bca4.svg";
export { ForwardRef as ReactComponent };